/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIAddressRequest
 */
export interface APIAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    address1: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    address3?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof APIAddressRequest
     */
    info?: string;
}

/**
 * Check if a given object implements the APIAddressRequest interface.
 */
export function instanceOfAPIAddressRequest(value: object): value is APIAddressRequest {
    if (!('address1' in value) || value['address1'] === undefined) return false;
    return true;
}

export function APIAddressRequestFromJSON(json: any): APIAddressRequest {
    return APIAddressRequestFromJSONTyped(json, false);
}

export function APIAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address1': json['address_1'],
        'address2': json['address_2'] == null ? undefined : json['address_2'],
        'address3': json['address_3'] == null ? undefined : json['address_3'],
        'zipCode': json['zip_code'] == null ? undefined : json['zip_code'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'info': json['info'] == null ? undefined : json['info'],
    };
}

export function APIAddressRequestToJSON(value?: APIAddressRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'address_1': value['address1'],
        'address_2': value['address2'],
        'address_3': value['address3'],
        'zip_code': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'info': value['info'],
    };
}

